// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"9b1b8c49","939":"eeb22b7d","977":"053238bc"}[chunkId] + ".chunk.js";
};